export default __webpack_public_path__ + "static/media/salvatagem.f66c7e21.svg";